import { MySettings } from "~/features/my-settings/index.tsx";
import { Construction } from "~/shared/components/construction/construction.tsx";
import { LoadingSpinner } from "~/shared/components/loading-spinner/loading-spinner.tsx";
import { useDeploymentType } from "~/shared/hooks/use-deployment-type.ts";
import { useFeatureFlagGate } from "~/shared/hooks/use-feature-flag-gate.ts";

export const MySettingsPage = () => {
	const { isReady, isEnabled } = useFeatureFlagGate("traxLtlMySettings");
	const { isInternal } = useDeploymentType();

	if (!isReady) {
		return <LoadingSpinner />;
	}

	return isEnabled && !isInternal ? <MySettings /> : <Construction />;
};
